export enum EnumUserAccessLevels {
    None = 'None',
    Read = 'Read',
    Full = 'Full',
}
